export default "__VITE_ASSET__BmmcWfnd__"